import React from 'react';
import { Gap } from 'lib/components/styles/layout';
import { ParagraphNormalBold600 } from 'lib/components/styles/typography';

interface IFormSectionProps {
  title: string;
  children: JSX.Element | JSX.Element[];
}

export const FormContainer = ({ title, children }: IFormSectionProps) => {
  return (
    <Gap gap='20px' flexDirection='column' alignItems='flex-start'>
      <ParagraphNormalBold600>{title}</ParagraphNormalBold600>
      {children}
    </Gap>
  );
};
